module.exports = __webpack_public_path__ + "img/sty_3.67943e77.png";